// src/api/wechat.js
import request from '@/utils/request'

// 微信授权登录接口，把code传给PHP后端
export const wxAuthLogin = (code) => {
  console.log('传给后端的微信授权code：', code)
  return request({
    url: 'wxauth',
    method: 'post',
    data: { code }
  })
}

// 校验登录态是否有效
export const checkAuthStatus = () => {
  const localToken = sessionStorage.getItem("auth_token")
  return request({
    url: 'checktoken',
    method: 'post',
    data: { token: localToken }
  })
}
